import type {CSSProperties} from "aphrodite";
import React from "react";

import type {ProfileModelType} from "#shared-package/profile-model.ts";

import WhamLink from "./wham-link.tsx";

type Props = {
    profile: ProfileModelType | null;
    profileLoading?: boolean;
    navItemStyles: Array<CSSProperties | null | undefined>;
    isResponsiveNavMenu: boolean;
    isOpen: boolean;
    onToggle: (opened: boolean) => void;
};

// TODO alexjuy: We'll likely want to move the majority of
// the logic in wham-link.tsx here and split out the possible
// link variants into their own components
const AINavItem = ({
    profile,
    profileLoading,
    navItemStyles,
    isResponsiveNavMenu,
    isOpen,
    onToggle,
}: Props): React.ReactElement | null => (
    <WhamLink
        profile={profile}
        profileLoading={profileLoading}
        navItemStyles={navItemStyles}
        isResponsiveNavMenu={isResponsiveNavMenu}
        isOpen={isOpen}
        onToggle={onToggle}
    />
);

export default AINavItem;
